const Divider = {
  baseStyle: {
    borderColor: 'greyScale.200',
    my: 0
  }
};

export default Divider;
